import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import React, { useEffect, useState } from "react";
import { getUserData } from "../../../utils/localStorage";
import { Checkbox } from "primereact/checkbox";
import { B2BOrderInfoEditAPI } from "../../../services/OrderEdit/orderInfoEdit";
import { Dropdown } from "primereact/dropdown";

const B2BOrderInfoEdit = ({
  orderInfoEditVisible,
  setOrderInfoEditVisible,
  customerOrdersData,
  storeId,
  storeUserId,
  storeCustomerId,
  processTime,
  sendResponse,
  storeCustomerData,
}) => {
  const { userProfileRole } = getUserData();
  const [otherRemarkValue, setOtherRemarkValue] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);
  const [statusValue, setStatusValue] = useState("");

  useEffect(() => {
    if (customerOrdersData !== null) {
      // setFirstNameValue(selectedUserItemValue?.firstName || '');
      setBookingDate(new Date(customerOrdersData?.createdDate));
      setDeliveryDate(new Date(customerOrdersData?.deliveryOn));
      setDeliveredOnDate(new Date(customerOrdersData?.deliveredOn));
      setOtherRemarkValue(customerOrdersData?.remarks || "");
    }
  }, [customerOrdersData]);

  const handleOtherRemarkChange = (text) => {
    setOtherRemarkValue(text);
  };

  const [bookingDate, setBookingDate] = useState(new Date());

  const [deliveryDate, setDeliveryDate] = useState(new Date());
  const [deliveredOnDate, setDeliveredOnDate] = useState(new Date());

  const [showBookingDatePicker, setShowBookingDatePicker] = useState(false);
  const [showDeliveryDatePicker, setShowDeliveryDatePicker] = useState(false);
  const [showDeliveredOnDatePicker, setShowDeliveredOnDatePicker] =
    useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const minimumDate = new Date();
  minimumDate.setMonth(minimumDate.getMonth());
  const minimumBookingDate = new Date();
  minimumBookingDate.setDate(minimumBookingDate.getDate() - 1);

  const maximumDate = new Date();
  maximumDate.setMonth(maximumDate.getMonth() + 3);
  const maximumBookingDate = new Date();
  maximumBookingDate.setDate(maximumBookingDate.getDate() + 1);

  const maximumValidDate = maximumDate;
  const maximumValidDeliveredOnDate = new Date(customerOrdersData?.deliveredOn);

  const [show, setShow] = useState(false);
  const handleShowHide = () => {
    setShow(!show);
  };

  const statusList = [
    {
      name: "PROCESSED",
      value: "PROCESSED",
    },
    {
      name: "DELIVERED",
      value: "DELIVERED",
    },
  ];

   const handleStatusChange = async (selectedItem) => {
      setStatusValue(selectedItem);
    };

  const handleBookingDateChange = (selectedDate) => {
    if (selectedDate) {
      let selectedDateOnly = selectedDate.toISOString().split("T")[0];
      let deliveryDateOnly = deliveryDate.toISOString().split("T")[0];
      const currentTime = new Date();
      selectedDate.setHours(
        currentTime.getHours(),
        currentTime.getMinutes(),
        currentTime.getSeconds(),
        currentTime.getMilliseconds()
      );

      if (selectedDateOnly > deliveryDateOnly) {
        setErrorMessage("Booking Date cannot be greater than Delivery Date");
      } else {
        setErrorMessage("");
        // const utcDate = new Date(
        //   Date.UTC(
        //     selectedDate.getFullYear(),
        //     selectedDate.getMonth(),
        //     selectedDate.getDate()
        //   )
        // );
        setBookingDate(selectedDate);
      }
      setShowBookingDatePicker(false);
    }
  };

  const handleDeliveryDateChange = (selectedDate) => {
    if (selectedDate) {
      let selectedDateOnly = selectedDate.toISOString().split("T")[0];
      let bookingDateOnly = bookingDate.toISOString().split("T")[0];

      const currentTime = new Date();
      selectedDate.setHours(
        currentTime.getHours(),
        currentTime.getMinutes(),
        currentTime.getSeconds(),
        currentTime.getMilliseconds()
      );

      if (selectedDateOnly < bookingDateOnly) {
        setErrorMessage("Delivery Date cannot be less than Booking Date");
      } else {
        setErrorMessage("");
        // const utcDate = new Date(
        //   Date.UTC(
        //     selectedDate.getFullYear(),
        //     selectedDate.getMonth(),
        //     selectedDate.getDate()
        //   )
        // );

        setDeliveryDate(selectedDate);
      }
      setShowDeliveryDatePicker(false);
    }
  };

  const handleDeliveredOnDateChange = (selectedDate) => {
    if (selectedDate) {
      let selectedDateOnly = selectedDate.toISOString().split("T")[0];
      let bookingDateOnly = bookingDate.toISOString().split("T")[0];

      const currentTime = new Date();
      selectedDate.setHours(
        currentTime.getHours(),
        currentTime.getMinutes(),
        currentTime.getSeconds(),
        currentTime.getMilliseconds()
      );

      if (selectedDateOnly < bookingDateOnly) {
        setErrorMessage("Delivery Date cannot be less than Booking Date");
      } else {
        setErrorMessage("");
        // const utcDate = new Date(
        //   Date.UTC(
        //     selectedDate.getFullYear(),
        //     selectedDate.getMonth(),
        //     selectedDate.getDate()
        //   )
        // );
        setDeliveredOnDate(selectedDate);
      }
      setShowDeliveredOnDatePicker(false);
    }
  };

  const handleModalClose = () => {
    setOrderInfoEditVisible(false);
    
  };

  // const convertToUTC = (date) => {
  //   if (!date || !(date instanceof Date)) {
  //     console.error("Invalid date:", date);
  //     return null;
  //   }
  //   const offset = date.getTimezoneOffset(); // Offset in minutes
  //   return new Date(date.getTime() - (offset * 60 * 1000) + 1000).toISOString();
  // };

  // // Convert dates
  // const currentDateTimeBookingDate = convertToUTC(bookingDate);

  const onUpdateButtonPress = () => {
    // Reset all previous errors

    if (!errorMessage) {
      if (!isSubmitButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsSubmitButtonPressed(true);

        const currentDateTimeBookingDate = new Date(bookingDate).toISOString();
        const currentDateTimeDeliveryDate = new Date(
          deliveryDate
        ).toISOString();
        const currentDateTimeDeliveredOnDate = new Date(
          deliveredOnDate
        ).toISOString();

        // const newDate = new Date(bookingDate);
        // newDate.setSeconds(newDate.getSeconds() + 1);
        // newDate.setHours(newDate.getHours(), newDate.getMinutes(), newDate.getSeconds(), newDate.getMilliseconds());

        // const updatedISOString = newDate.toISOString();

        const data = {
          id: customerOrdersData?.id,
          status: statusValue === "" ? customerOrdersData?.status : statusValue,
          storeUserId: storeUserId,
          createdDate: currentDateTimeBookingDate,
          deliveryOn: currentDateTimeDeliveryDate,
          urgentDelivery: false,
          deliveryRequest: false,
          regenerateInvoice: false,
          regenerateQRCode: false,
          remarks: otherRemarkValue,
          // deliveredOn: currentDateTimeDeliveredOnDate,
          deliveredOn: new Date(),
          customerName: [
            storeCustomerData?.brandCustomer?.firstName,
            storeCustomerData?.brandCustomer?.lastName,
          ]
            .filter(
              (name) =>
                name &&
                name !== "null" &&
                name !== "undefined"
            )
            .join(" "),
          customerMobile: storeCustomerData?.brandCustomer?.mobile,
          customerAddress: storeCustomerData?.address?.address,
        };

        // Call the service function for creating pickup request
        B2BOrderInfoEditAPI(storeCustomerId, storeId, customerOrdersData?.id, data)
          .then((response) => {
            if (!response.data.error) {
              const Res = response.data;
              if (Res) {
                const message = Res.message;
                const status = Res.status;
                // sendResponse({message, status, modalFun: false});
                // Reset state variables
                if (status === true) {
                  setModalVisible(true);
                  setModalStatus("success");
                  setModalText(message);
                } else {
                  setModalVisible(true);
                  setModalStatus("not Success");
                  setModalText(message);
                }

                setIsSubmitButtonPressed(false);
                 
                sendResponse({
                  message,
                  status,
                  modalFun: false,
                });
                setErrorMessage("");
                setOrderInfoEditVisible(false);
              }
            }
          })
          .catch((err) => {
            console.error("Error:", err);
          });
      }
    } else {
      setIsSubmitButtonPressed(false);
   
    }
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={orderInfoEditVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!orderInfoEditVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-1 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <div></div>

              <p className=" text-3xl text-primary-50 font-semibold">
                Challan Info
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-xl text-primary-50 border-1 p-1"
              ></Button>
            </div>

            {["DONE", "DELIVERED"].includes(customerOrdersData?.status) ? (
              <div className="flex justify-content-between align-items-center mx-4">
                <p className="text-xl font-medium capitalize p-0">
                  Delivered On Date
                </p>
                <Calendar
                  id="buttondisplay"
                  value={deliveredOnDate}
                  minDate={bookingDate}
                  maxDate={maximumValidDeliveredOnDate}
                  onChange={(e) => handleDeliveredOnDateChange(e.value)}
                  showIcon
                  className="w-auto"
                  dateFormat="dd/mm/yy"
                />
              </div>
            ) : (
              <div
                className="h-20rem scroll-bar"
                style={{
                  overflowY: "scroll",
                }}
              >
                <React.Fragment>
                  <div className="flex justify-content-between align-items-center mx-4 my-2">
                    <p className="text-xl font-medium capitalize p-0">
                      Booking Date
                    </p>
                    <Calendar
                      id="buttondisplay"
                      value={bookingDate}
                      // minDate={bookingDate}
                      maxDate={deliveryDate}
                      onChange={(e) => handleBookingDateChange(e.value)}
                      showIcon
                      className="w-auto p-0"
                      dateFormat="dd/mm/yy"
                    />
                  </div>
                  <div className="flex justify-content-between align-items-center mx-4 my-2">
                    <p className="text-xl font-medium capitalize">
                      Delivery Date
                    </p>
                    <Calendar
                      id="buttondisplay"
                      value={deliveryDate}
                      minDate={bookingDate}
                      maxDate={maximumValidDate}
                      onChange={(e) => handleDeliveryDateChange(e.value)}
                      showIcon
                      className="w-auto p-0"
                      dateFormat="dd/mm/yy"
                    />
                  </div>

                    <div className="flex-1 mx-4 mb-3">
                      <Dropdown
                        value={statusValue}
                        onChange={(e) => handleStatusChange(e.value)}
                        options={statusList}
                        optionLabel="name"
                        placeholder="Select Status"
                        className="w-full  bg-white-alpha-20 border-round-lg p-0 text-lg text-primary-50"
                      />
                    </div>

                  <div className="flex-1 mx-4 my-2">
                    <div
                      className="border-round-xl shadow-2"
                      style={{
                        backgroundColor: "#fff",
                      }}
                    >
                      <InputText
                        placeholder="Other Remark"
                        value={otherRemarkValue}
                        maxLength={50}
                        onChange={(e) =>
                          handleOtherRemarkChange(e.target.value)
                        }
                        className="w-full border-none px-3 text-md "
                      ></InputText>
                    </div>
                  </div>
                   
                  <div
                    className="shadow-2 mx-4 border-2 border-round-lg cursor-pointer my-2"
                    style={{ borderColor: "#276bcf" }}
                  >
                    <div
                      className="px-3 pb-1 flex flex-row justify-content-between align-items-center"
                      style={{
                        backgroundColor: "#276bcf",
                      }}
                      onClick={handleShowHide}
                    >
                      <p className="text-white text-xl font-bold capitalize">
                        Get Customer Info
                      </p>
                      <i
                        className={
                          !show ? "pi pi-angle-down" : "pi pi-angle-up"
                        }
                        style={{
                          fontSize: "25px",
                          cursor: "pointer",
                          color: "#fff",
                        }}
                      ></i>
                    </div>
                  </div>
                  {show && (
                    <div className="flex-1 flex mx-4 gap-4 my-2">
                      <div
                        className="border-round-xl shadow-2"
                        style={{
                          backgroundColor: "#fff",
                        }}
                      >
                        <InputText
                          placeholder="Customer Name"
                          value={[
                            storeCustomerData?.brandCustomer?.firstName,
                            storeCustomerData?.brandCustomer?.lastName,
                          ]
                            .filter(
                              (name) =>
                                name &&
                                name !== "null" &&
                                name !== "undefined"
                            )
                            .join(" ")}
                          className="w-full border-none px-3 text-md "
                          disabled={true}
                        ></InputText>
                      </div>
                      <div
                        className="border-round-xl shadow-2"
                        style={{
                          backgroundColor: "#fff",
                        }}
                      >
                        <InputText
                          placeholder="Mobile No."
                          value={storeCustomerData?.brandCustomer?.mobile}
                          className="w-full border-none px-3 text-md "
                          disabled={true}
                        ></InputText>
                      </div>
                      <div
                        className="border-round-xl shadow-2"
                        style={{
                          backgroundColor: "#fff",
                        }}
                      >
                        <InputText
                          placeholder="Customer Address"
                          value={storeCustomerData?.address?.address}
                          className="w-full border-none px-3 text-md "
                          disabled={true}
                        ></InputText>
                      </div>
                    </div>
                  )}
                </React.Fragment>
              </div>
            )}

            <Button
              disabled={isSubmitButtonPressed}
              onClick={onUpdateButtonPress}
              className=" mb-3 mx-4 border-round-xl "
            >
              <p className=" w-full text-2xl  font-semibold flex justify-content-center">
                Submit Request
              </p>
            </Button>
          </div>
        )}
      ></Dialog>
    </div>
  );
};

export default B2BOrderInfoEdit;
